(function () {
  const TRACKING_KEYS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  const STORAGE_PREFIX = 'cs_attr_';
  const COOKIE_DAYS = 90;

  const ATTRIBUTION_BLOCK_START = '[Google Attribution Start]';
  const ATTRIBUTION_BLOCK_END = '[Google Attribution End]';

  function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;

    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax';
  }

  function getCookie(name) {
    const encodedName = encodeURIComponent(name) + '=';
    const parts = document.cookie.split(';');

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();

      if (part.indexOf(encodedName) === 0) {
        return decodeURIComponent(part.substring(encodedName.length));
      }
    }

    return '';
  }

  function saveValue(key, value) {
    if (!value) return;

    try {
      localStorage.setItem(STORAGE_PREFIX + key, value);
    } catch (e) {}

    setCookie(STORAGE_PREFIX + key, value, COOKIE_DAYS);
  }

  function readValue(key) {
    try {
      const localValue = localStorage.getItem(STORAGE_PREFIX + key);
      if (localValue) return localValue;
    } catch (e) {}

    return getCookie(STORAGE_PREFIX + key);
  }

  function captureUrlParams() {
    const params = new URLSearchParams(window.location.search);

    TRACKING_KEYS.forEach(function (key) {
      const value = params.get(key);

      if (value) {
        saveValue(key, value);
      }
    });

    if (!readValue('landing_page')) {
      saveValue('landing_page', window.location.href);
    }

    if (!readValue('referrer')) {
      saveValue('referrer', document.referrer || '');
    }

    if (!readValue('first_touch_timestamp')) {
      saveValue('first_touch_timestamp', new Date().toISOString());
    }
  }

  function buildCartAttributes() {
    const attributes = {};

    const mapping = {
      gclid: 'GCLID',
      gbraid: 'GBRAID',
      wbraid: 'WBRAID',
      utm_source: 'UTM Source',
      utm_medium: 'UTM Medium',
      utm_campaign: 'UTM Campaign',
      utm_term: 'UTM Term',
      utm_content: 'UTM Content'
    };

    Object.keys(mapping).forEach(function (key) {
      const value = readValue(key);

      if (value) {
        attributes[mapping[key]] = value;
      }
    });

    const landingPage = readValue('landing_page');
    const referrer = readValue('referrer');
    const timestamp = readValue('first_touch_timestamp');

    if (landingPage) attributes['Landing Page'] = landingPage;
    if (referrer) attributes['Referrer'] = referrer;
    if (timestamp) attributes['First Touch Timestamp'] = timestamp;

    return attributes;
  }

  function buildAttributionNoteBlock() {
    const values = {
      GCLID: readValue('gclid'),
      GBRAID: readValue('gbraid'),
      WBRAID: readValue('wbraid'),
      'UTM Source': readValue('utm_source'),
      'UTM Medium': readValue('utm_medium'),
      'UTM Campaign': readValue('utm_campaign'),
      'UTM Term': readValue('utm_term'),
      'UTM Content': readValue('utm_content'),
      'Landing Page': readValue('landing_page'),
      Referrer: readValue('referrer'),
      'First Touch Timestamp': readValue('first_touch_timestamp')
    };

    const lines = [];

    Object.keys(values).forEach(function (key) {
      if (values[key]) {
        lines.push(key + ': ' + values[key]);
      }
    });

    if (!lines.length) return '';

    return [
      ATTRIBUTION_BLOCK_START,
      'Google Attribution:',
      lines.join('\n'),
      ATTRIBUTION_BLOCK_END
    ].join('\n');
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function removeExistingAttributionBlock(note) {
    if (!note) return '';

    const pattern = new RegExp(
      '\\n?' +
        escapeRegExp(ATTRIBUTION_BLOCK_START) +
        '[\\s\\S]*?' +
        escapeRegExp(ATTRIBUTION_BLOCK_END),
      'g'
    );

    return note.replace(pattern, '').trim();
  }

  function mergeNoteWithAttribution(existingNote, attributionBlock) {
    const cleanNote = removeExistingAttributionBlock(existingNote || '');

    if (!attributionBlock) return cleanNote;

    if (cleanNote) {
      return cleanNote + '\n\n' + attributionBlock;
    }

    return attributionBlock;
  }

  function updateCartWithAttribution(callback) {
    const attributes = buildCartAttributes();
    const attributionBlock = buildAttributionNoteBlock();

    if (!Object.keys(attributes).length && !attributionBlock) {
      if (typeof callback === 'function') callback();
      return;
    }

    fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const existingNote = cart.note || '';
        const newNote = mergeNoteWithAttribution(existingNote, attributionBlock);

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            note: newNote,
            attributes: attributes
          })
        });
      })
      .then(function () {
        if (typeof callback === 'function') callback();
      })
      .catch(function (error) {
        console.warn('Google attribution cart update failed:', error);

        if (typeof callback === 'function') callback();
      });
  }

  function interceptCheckoutClicks() {
    document.addEventListener(
      'click',
      function (event) {
        const checkoutButton = event.target.closest(
          'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout-button], .rebuy-cart__checkout-button'
        );

        if (!checkoutButton) return;

        const href = checkoutButton.getAttribute('href');

        event.preventDefault();
        event.stopPropagation();

        updateCartWithAttribution(function () {
          if (href) {
            window.location.href = href;
            return;
          }

          const form = checkoutButton.closest('form');

          if (form) {
            form.submit();
            return;
          }

          window.location.href = '/checkout';
        });
      },
      true
    );
  }

  captureUrlParams();
  updateCartWithAttribution();
  interceptCheckoutClicks();
})();